var render = function render(){var _vm=this,_c=_vm._self._c;return _c('editor',_vm._b({attrs:{"api-key":_vm.key,"init":{plugins: 'wordcount'},"data-cy":"editor"}},'editor',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }